import React from 'react';

export default function ChatGroupAltIcon({as = React.Fragment, Tag = as, ...props}) {
  return (
    <Tag {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-chat-group-alt"><rect width="16" height="13" x="2" y="2" className="secondary" rx="2"/><path className="primary" d="M6 16V8c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v13a1 1 0 0 1-1.7.7L16.58 18H8a2 2 0 0 1-2-2z"/></svg>
    </Tag>
  )
};
